export const SEARCH_RESULTS_LISTBOX_ID = "search-results-listbox";
